<script lang="ts">
</script>

<div class="divider-conatiner"></div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .divider {
    &-conatiner {
      height: 10px;
      width: 100%;
      background-color: $neutral-light-04;
      box-shadow:
        inset 0px -1px 1px #0000000a,
        inset 0px 1px 1px #0000000a;
      @include desktop-min-width {
        height: 20px;
      }
    }
  }
</style>
